export type JourneyRedirect =
  | "root_saved_team" | "root_welcome" | "protected_login" | "auth_return"
  | "auth_welcome" | "demo" | "legacy_ai" | "team_canonical"
  | "team_missing" | "team_access" | "unknown_route";

export function redirectState(reason: JourneyRedirect, state?: Record<string, unknown> | null) {
  return { ...state, journeyRedirect: reason };
}

/** Keep the router destination, not window.location's path outside HashRouter. */
export function loginReturnPath(from: unknown): string | null {
  let path: string;
  if (typeof from === "string") {
    path = from;
  } else if (from && typeof from === "object" && "pathname" in from && typeof from.pathname === "string") {
    const search = "search" in from && typeof from.search === "string" ? from.search : "";
    const hash = "hash" in from && typeof from.hash === "string" ? from.hash : "";
    path = `${from.pathname}${search}${hash}`;
  } else {
    return null;
  }
  if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\") ||
      /^\/login(?:[/?#]|$)/i.test(path)) return null;
  return path;
}

/** Change only the team slug; keep section, archive, query and fragment intact. */
export function canonicalTeamPath(slug: string, location: { pathname: string; search?: string; hash?: string }): string {
  const suffix = location.pathname.split("/").slice(3).join("/");
  return `/team/${encodeURIComponent(slug)}${suffix ? `/${suffix}` : ""}${location.search ?? ""}${location.hash ?? ""}`;
}
